import * as types from '../config/actionTypes';

const TradeActions = {
	setTrades: (data) => ({ type: types.SET_TRADES, data }),
};

export default TradeActions;